//
//
//
//
//
//
//

export default {
    name: 'Noresult',
};
